import { render, staticRenderFns } from "./ManageDeliveryDriverView.vue?vue&type=template&id=19fd5d7a"
import script from "./ManageDeliveryDriverView.vue?vue&type=script&lang=ts"
export * from "./ManageDeliveryDriverView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports